module.exports = __webpack_public_path__ + "img/IMG_9924.6f42e2ec.jpg";